import React from 'react'
import '../pages/ContactUs.css'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faEnvelope, faGlobe } from '@fortawesome/free-solid-svg-icons'
import AppButton from '../components/AppButton'

const CONTACT_DETAILS = [
    {
        icon: faLocationDot,
        label: 'Mumbai Office',
        value: 'H-2, Ranjeet Studio, Dada Saheb Phalke Road, Dadar East,\nMumbai - 400014',
    },
    {
        icon: faEnvelope,
        label: 'Email Support',
        value: 'info@resolutionexperts.in',
    },
    {
        icon: faGlobe,
        label: 'Website',
        value: 'www.resolutionexperts.in',
    },
]

function ContactUs() {
    return (
        <Container fluid className='contactUsContainer'>
            <Row className='align-items-center'>
                <Col md={5} className='mb-4 mb-md-0'>
                    <h2 className='contactHeading'>Get In Touch</h2>
                    <p className='contactSubheading'>
                        We are here to assist you. Our team will review your inquiry and respond promptly to address your needs.
                    </p>

                    <div className='contactDetails'>
                        {CONTACT_DETAILS.map(({ icon, label, value }) => (
                            <div className='contactDetailItem' key={label}>
                                <FontAwesomeIcon icon={icon} className='contactDetailIcon' />
                                <div>
                                    <div className='contactDetailLabel'>{label}</div>
                                    <div className='contactDetailValue'>
                                        {value.split('\n').map((line, index, lines) => (
                                            <React.Fragment key={index}>
                                                {line}
                                                {index < lines.length - 1 && <br />}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Col>

                <Col md={7}>
                    <div className='contactFormCard'>
                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className='mb-3' controlId='contactName'>
                                        <Form.Label>Full Name</Form.Label>
                                        <Form.Control type='text' placeholder='Enter Your Name' />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className='mb-3' controlId='contactMail'>
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control type='email' placeholder='email@example.com' />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className='mb-4' controlId='contactMsg'>
                                <Form.Label>Message</Form.Label>
                                <Form.Control as='textarea' rows={5} placeholder='How can we help you?' />
                            </Form.Group>

                            <AppButton type='submit'>Submit enquiry</AppButton>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default ContactUs
